import React from "react";

const FacebookButton = () => (
    <a href="https://facebook.com/globalelitist" className="btn mr-2 py-2">
        <i className="fab fa-facebook-f" />
    </a>
);

export { FacebookButton };
